import React from 'react';
import { ScrollArea } from '@/components/ui/scroll-area';
import ActionBar from '@/components/ActionBar';
import { useState } from 'react';
import Summary from '@/components/Summary';
import { AnalysisSpec, IncomeEvaluations, SummarySelect } from '../ProductInterpretationTab/index';
import { SkeletonDashboard } from '@/components/loading/Skeleton';
const ProductInterpretation: React.FC<{ totalData: any; loading: boolean }> = ({
  totalData,
  loading
}) => {
  console.log('totalData', totalData);
  console.log('loading', loading);
  const [selectAll, setSelectAll] = useState(false);
  const [isIndeterminate, setIsIndeterminate] = useState(false);
  const handleSelectAll = (value: boolean) => {
    setSelectAll(value);
    setIsIndeterminate(false);
  };

  const product_info = totalData?.product_info || [];
  const product1Data = product_info[0] || {};

  // 选中的指标
  const [selectedMetrics, setSelectedMetrics] = useState({
    industryDistribution: true,
    tradingEvaluation: false
  });

  if (loading) {
    return (
      <div className="absolute left-0 top-0 z-[111111] flex h-full w-full items-center justify-center">
        <SkeletonDashboard className="absolute left-0 top-0 w-full px-0" />
      </div>
    );
  }

  return (
    <>
      <ScrollArea className="scroll-area-block h-full w-full pb-[50px]">
        {/* 深度解读 */}
        <AnalysisSpec
          fundName={product1Data.产品名称1}
          fundCode={product1Data.基金代码}
          fundInfo={product1Data}
        />
        {/* ai总结 */}
        <Summary isShowSuggestions={false} title="AI总结" content={totalData.一句话解读} />
        {/* 收益与回撤概览 */}
        <IncomeEvaluations selectedMetrics={selectedMetrics} totalData={totalData} />
        <div className="grid gap-3">
          {/* 产品优势 */}
          <SummarySelect type="advantage" selected={true} content="">
            <div className="text-left text-xs leading-relaxed text-gray-900">
              <ul className="list-inside list-disc text-sm">
                {(totalData.产品优势 || []).map((item: string, index: number) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>
            </div>
          </SummarySelect>

          {/* 风险提示 */}
          <SummarySelect type="risk" selected={true} content="">
            <div className="text-left text-xs leading-relaxed text-gray-900">
              <ul className="list-inside list-disc text-sm">
                {(totalData.风险提示 || []).map((item: string, index: number) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>
            </div>
          </SummarySelect>

          {/* 操作建议 */}
          <SummarySelect type="suggestion" selected={true} content="">
            <div className="text-left text-xs leading-relaxed text-gray-900">
              <ul className="list-inside list-disc text-sm">
                {(totalData.操作建议 || []).map((item: string, index: number) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>
            </div>
          </SummarySelect>
        </div>
      </ScrollArea>
      {/* 操作栏 */}
      <ActionBar
        selectAll={selectAll}
        isIndeterminate={isIndeterminate}
        onUpdateSelectAll={handleSelectAll}
        className="px-0"
      />
    </>
  );
};

export default ProductInterpretation;
